module.exports = __webpack_public_path__ + "img/product-wave-down.70c0103a.svg";